import React, { PropsWithChildren } from 'react';
import { mergeClasses } from '@/utils/style';
import { Badge } from '@/components/Badge/Badge';
import { Breadcrumbs, BreadcrumbItem } from '@/components/Breadcrumbs/Breadcrumbs';

interface Props {
	label?: string | React.ReactNode;
	className?: string;
	circleClassName?: string;
	contentClassName?: string;
	breadcrumbs: BreadcrumbItem[];
}

export function HeroWithBreadcrumbs({
	breadcrumbs,
	label,
	className,
	circleClassName,
	contentClassName,
	children,
}: PropsWithChildren<Props>): React.JSX.Element {
	return (
		<div className={mergeClasses('relative overflow-hidden bg-blue-900', className)}>
			{circleClassName && <div className={mergeClasses('bgCircle absolute', circleClassName)} />}
			<div className={mergeClasses('relative z-10 pt-[7.5rem] pb-14 lg:pt-[9.5rem] lg:pb-20')}>
				<div className="mx-auto hidden max-w-[115rem] px-12 xl:block">
					<Breadcrumbs variant="inverted" items={breadcrumbs} />
				</div>
				<div
					className={mergeClasses(
						'mx-auto mt-0 px-4',
						label ? 'xl:mt-12' : 'xl:mt-20',
						contentClassName
					)}
				>
					{label && (
						<div className="mb-4 text-center lg:mb-6">
							<Badge title={label} />
						</div>
					)}
					<div>{children}</div>
				</div>
			</div>
		</div>
	);
}
